import { Grid2 } from "@mui/material";
import DownloadSheet from "./DownloadSheet";
import UploadSheet from "./UploadSheet";

const TopBar = () => {
  return (
    <Grid2
      container
      {...{
        padding: 2,
        paddingTop: 0,
        paddingBottom: 2,
        columnSpacing: 2,
        size: 12,
        justifyContent: "space-between",
      }}
    >
        <UploadSheet />
        <DownloadSheet />
    </Grid2>
  );
};

export default TopBar;
